import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { drumSynth } from "../services/drum-synth";

@customElement("sound-compare")
export class SoundCompare extends LitElement {
  @state() private playing = "";

  static styles = css`
    :host{display:block}.intro{max-width:760px;color:#aaa;line-height:1.65}.choices{display:grid;grid-template-columns:1fr auto 1fr;gap:12px;align-items:stretch;margin-top:24px}.choice{min-height:190px;padding:25px;text-align:left;border:1px solid #3b3b40;border-radius:14px;background:#171719;color:#eee;cursor:pointer}.choice:hover,.choice:focus-visible,.choice.active{border-color:#d7ff3f;outline:none;background:#202318}.choice small{color:#d7ff3f;font:700 10px/1 sans-serif;text-transform:uppercase;letter-spacing:.12em}.choice b{display:block;font-size:30px;margin:16px 0 10px}.choice span{color:#999;line-height:1.5}.versus{display:grid;place-items:center;color:#666;font:700 10px/1 monospace}.compare{display:block;margin:14px auto 0;border:0;border-radius:8px;background:#d7ff3f;color:#09090b;padding:13px 18px;font-weight:800;cursor:pointer}.note{max-width:760px;margin:24px auto 0;padding:18px;border-left:3px solid #d7ff3f;background:#141416;color:#aaa;line-height:1.55}.note b{color:#eee}@media(max-width:650px){.choices{grid-template-columns:1fr}.versus{min-height:25px}}
  `;

  private hit(kind: "wood" | "steel"): void {
    this.playing = kind;
    void drumSynth.hit("snare", undefined, kind === "wood" ? "warm" : "bright");
    window.setTimeout(() => { this.playing = ""; }, 500);
  }

  private compare(): void {
    this.hit("wood");
    window.setTimeout(() => this.hit("steel"), 850);
  }

  render() {
    return html`
      <p class="intro">The snare's shell is the round body around the drum. Change only that material and the character can change. This demonstration exaggerates the contrast slightly so a new listener can learn what to notice.</p>
      <div class="choices">
        <button class="choice ${this.playing === "wood" ? "active" : ""}" @click=${() => this.hit("wood")}><small>A · wood shell</small><b>Rounder, shorter</b><span>More low body and less lingering metallic ring.</span></button>
        <span class="versus">THEN</span>
        <button class="choice ${this.playing === "steel" ? "active" : ""}" @click=${() => this.hit("steel")}><small>B · steel shell</small><b>Brighter, longer</b><span>More high crack and a clearer ring after the hit.</span></button>
      </div>
      <button class="compare" @click=${this.compare}>Play A, then B</button>
      <p class="note"><b>This is a tendency, not a law.</b> How tightly the drum is tuned and how much its ring is damped can matter as much as the shell. The simple lesson: material changes the color of a hit; it does not decide whether a drum sounds good.</p>
    `;
  }
}
